import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-loading-logo",
  templateUrl: "./loading-logo.component.html",
  styleUrls: ["./loading-logo.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoadingLogoComponent {}
